import { ReactNode } from 'react';
import { DbContext } from './context';
import { db } from '../../main';


export const DbProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    return (
        <DbContext.Provider value={{ db }}>
            {children}
        </DbContext.Provider>
    );
};



